import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';

import SvgIcon from '../SvgIcon';
import Loader from '../Loader';

import './Button.scss';

// eslint-disable-next-line no-script-url
const noopStr = 'javascript:;';

class Button extends Component {
  static defaultProps = {
    variant: 'default',
    size: 'm'
  }

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    if (this.props.disabled) {
      e.stopPropagation();
    } else {
      if (!this.props.loading && this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }

  handleMouseEnter(e) {
    e.preventDefault();
    if (!this.props.loading && this.props.onMouseEnter) {
      this.props.onMouseEnter(e)
    }    
  }

  handleMouseLeave(e) {
    e.preventDefault();
    if (!this.props.loading && this.props.onMouseLeave) {
      this.props.onMouseLeave(e)
    }    
  }
  
  render() {
    const baseClassName = 'pb-button';

    const {
      label,
      parentClassName,
      iconLeft,
      iconRight,
      iconSize,
      alignIconCenter,
      themeAlignIconCenter,
      fullWidth,
      rounded,
      long,
      disabled,
      matchInputFields,
      loading,
      variant,
      inGroup,
      mergeTop,
      mergeBottom,
      mergeSides,
      formButton,
      size,
      type,
      mergeLeft,
      mergeRight,
      greyBorder,
      textAlignLeft,
      noPaddingLeft,
      section,
      t,
      isRtl,
      noMargin,
      loaderSize,
      csf,
      noIconTitle,
      title,
      count
    } = this.props;

    let leftIconEl;
    if (loading) {
      leftIconEl = <Loader size={loaderSize || "m"} parentClassName={isRtl ? `${baseClassName}__icon-right` : `${baseClassName}__icon-left`} />
    } else if (iconLeft) {
      leftIconEl = <SvgIcon name={iconLeft} title={noIconTitle ? null : section ? t(`SvgTitle.${section}-${iconLeft}`) : t(`SvgTitle.${iconLeft}`)} size={iconSize || "m"} parentClassName={isRtl ? `${baseClassName}__icon-right` : `${baseClassName}__icon-left`} />
    }

    let rightIconEl;
    if (iconRight) {
      rightIconEl = <SvgIcon name={iconRight} title={(themeAlignIconCenter || noIconTitle) ? null : (section ? t(`SvgTitle.${section}-${iconRight}`) : t(`SvgTitle.${iconRight}`))} size={iconSize} 
      parentClassName={`${isRtl ? `${baseClassName}__icon-left` : `${baseClassName}__icon-right`} ${alignIconCenter? `${baseClassName}__icon-right--align-center` : ''} ${ themeAlignIconCenter? `${baseClassName}__theme-icon-right--align-center` : ''}`} />
    }

    let countEl;
    if (count > 0) {
      countEl = <div className={isRtl ? `${baseClassName}__count-el ${baseClassName}__count-el--rtl` : `${baseClassName}__count-el`}>{count}</div>
    }

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--${variant}`]: variant,
      [`${baseClassName}--size-${size}`]: size,
      [`${baseClassName}--disabled`]: disabled || loading,
      [`${baseClassName}--loading`]: loading,
      [`${baseClassName}--match-input-fields`]: matchInputFields,
      [`${baseClassName}--long`]: long,
      [`${baseClassName}--full-width`]: fullWidth,
      [`${baseClassName}--rounded`]: rounded,
      [`${baseClassName}--in-group-${inGroup}`]: inGroup,
      [`${baseClassName}--merge-top`]: mergeTop,
      [`${baseClassName}--merge-bottom`]: mergeBottom,
      [`${baseClassName}--merge-sides`]: mergeSides,
      [`${baseClassName}--merge-left`]: mergeLeft,
      [`${baseClassName}--merge-right`]: mergeRight,
      [`${baseClassName}--form-button`]: formButton,
      [`${baseClassName}--no-padding-left`]: noPaddingLeft,
      [`${baseClassName}--rtl`]: isRtl,
      [`${baseClassName}--grey-border`]: greyBorder,
      [`${baseClassName}--csf`]: csf,
      [`${baseClassName}--text-align-left`]: textAlignLeft,
      [parentClassName]: parentClassName,
      [`${baseClassName}--no-margin`]: noMargin,
      [`${baseClassName}--count-header`]: count > 0
    }

    return (
       type === "formSubmit"
        ?
        <button type="submit" className={classNames(classes)} href={noopStr} onClick={this.handleClick}>
          {leftIconEl}
          {label}
          {rightIconEl}
        </button>
        :
        <a className={classNames(classes)} href={noopStr} onClick={this.handleClick} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} title={title} >
          {leftIconEl}
          {label}
          {rightIconEl}
          {countEl}
        </a>
    );
  }
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  parentClassName: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  iconSize: PropTypes.string,
  fullWidth: PropTypes.bool,
  matchInputFields: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  inGroup: PropTypes.oneOf([
    'first',
    'last',
    'middle'
  ]),
  mergeTop: PropTypes.bool,
  mergeBottom: PropTypes.bool,
  mergeSides: PropTypes.bool,
  /* Default variant is default */
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'primary-complement',
    'info',
    'danger',
    'warning',
    'success',
    'facebook',
    'google',
    'fab',
    'transparent',
    'flp',
    'flp-complement'
  ]),
  /* Default size is m */
  size: PropTypes.oneOf([
    'm',
    's',
    'l',
    'xl',
    'xxl'
  ]),
  section: PropTypes.string
};

export default translate()(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx